import React from 'react';
import {ValueCell} from '../../../../../../components/initial-plan/ValueCell';
import {Data, Title} from '../ProjectScopingTotals_styled';
import {Tile, TileRow} from './Tile_styled';
import {useIntl} from 'react-intl';
import {useProjectTotals} from '../ProjectScopingTotalsContext';

export const AvailabilityTile = (): JSX.Element => {
	const intl = useIntl();
	const {totalsData} = useProjectTotals();
	return (
		<Tile>
			<TileRow>
				<Title>{intl.formatMessage({id: 'common.total_availability'})}</Title>
				<Data small>
					<ValueCell noJustify type={ValueCell.VALUE_TYPE.TIME} value={totalsData.totalAvailability} />
				</Data>
			</TileRow>
			<TileRow>
				<Title>{intl.formatMessage({id: 'common.remaining_availability'})}</Title>
				<Data small>
					<ValueCell noJustify type={ValueCell.VALUE_TYPE.TIME} value={totalsData.remainingAvailability} />
				</Data>
			</TileRow>
		</Tile>
	);
};
